import { createReducer, on } from '@ngrx/store';
import remoteActions from './remote.actions';
import { ApiState } from '../../model/api-state.model';
import { RemoteAccessResponseSuccess } from '../../model/remote-access.model';
import { RemoteSendOtpResponseSuccess } from '../../model/remote-send-otp.model';
import { RemoteCheckSmsTokenResponseSuccess } from '../../model/remote-check-sms-token.model';
import AppError from 'src/app/model/app-error';

export { remoteActions as actions };

export * from './remote.selectors';

export interface State {
  initState: ApiState;
  initData: RemoteAccessResponseSuccess | null;
  initError: AppError | null;
  sendSmsTokenState: ApiState;
  sendSmsTokenData: RemoteSendOtpResponseSuccess | null;
  sendSmsTokenError: AppError | null;
  verifySmsTokenState: ApiState;
  verifySmsTokenData: RemoteCheckSmsTokenResponseSuccess | null;
  verifySmsTokenError: AppError | null;
  navigationError: string | null;
  remoteId: string | null;
}

export const initialState: State = {
  initState: ApiState.idle,
  initData: null,
  initError: null,
  sendSmsTokenState: ApiState.idle,
  sendSmsTokenData: null,
  sendSmsTokenError: null,
  verifySmsTokenState: ApiState.idle,
  verifySmsTokenData: null,
  verifySmsTokenError: null,
  navigationError: null,
  remoteId: null,
};

export const reducer = createReducer(
  initialState,
  on(remoteActions.reset, () => initialState),
  on(remoteActions.initStart, (state) => ({ ...state, initState: ApiState.pending, initData: null, initError: null })),
  on(remoteActions.initSuccess, (state, { success }) => ({ ...state, initState: ApiState.success, initData: success, initError: null })),
  on(remoteActions.initError, (state, { error }) => ({ ...state, initState: ApiState.error, initData: null, initError: error })),
  on(remoteActions.sendSmsTokenStart, (state) => ({
    ...state,
    sendSmsTokenState: ApiState.pending,
    sendSmsTokenData: null,
    sendSmsTokenError: null,
  })),
  on(remoteActions.sendSmsTokenSuccess, (state, { success }) => ({
    ...state,
    sendSmsTokenState: ApiState.success,
    sendSmsTokenData: success,
    sendSmsTokenError: null,
  })),
  on(remoteActions.sendSmsTokenError, (state, { error }) => ({
    ...state,
    sendSmsTokenState: ApiState.error,
    sendSmsTokenData: null,
    sendSmsTokenError: error,
  })),
  on(remoteActions.verifySmsTokenStart, (state) => ({
    ...state,
    verifySmsTokenState: ApiState.pending,
    verifySmsTokenData: null,
    verifySmsTokenError: null,
  })),
  on(remoteActions.verifySmsTokenSuccess, (state, { success }) => ({
    ...state,
    verifySmsTokenState: ApiState.success,
    verifySmsTokenData: success,
    verifySmsTokenError: null,
  })),
  on(remoteActions.verifySmsTokenError, (state, { error }) => ({
    ...state,
    verifySmsTokenState: ApiState.error,
    verifySmsTokenData: null,
    verifySmsTokenError: error,
  })),
  on(remoteActions.pushNavigationError, (state, { error }) => ({ ...state, navigationError: error })),
  on(remoteActions.resetNavigationError, (state) => ({ ...state, navigationError: null })),
  on(remoteActions.setRemoteId, (state, { remoteId }) => ({ ...state, remoteId })),
);
